var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('ProductForm',{attrs:{"productId":_vm.currentId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }